import translation from '../language/translation.json';
import moment from "moment";
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/pt';
import i18n from "../language/i18n";

export class Utils {

    static getBrowserLanguage(): string {
        return navigator.language.substring(0, 2)
    }

    static isLanguageSupported(lang: string): boolean {
        return translation.language[lang]
    }

    static tryParseDate(value: string) {
        moment.locale(i18n.language)
        const date = moment(value, "YYYY-MM-DD", true)
        return date.format("Do MMM YYYY")
    }

    static addExtensionIfMissing(filename: string, mimeType: string): string {

        const mimeToExtension = {
            // Documents
            'application/pdf': '.pdf',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'application/vnd.ms-excel': '.xls',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
            'application/vnd.ms-powerpoint': '.ppt',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
            'text/plain': '.txt',
            'text/csv': '.csv',
            'application/rtf': '.rtf',
            'application/vnd.oasis.opendocument.text': '.odt',

            // Images
            'image/jpeg': '.jpg',
            'image/jpg': '.jpg',
            'image/png': '.png',
            'image/gif': '.gif',
            'image/bmp': '.bmp',
            'image/webp': '.webp',
            'image/svg+xml': '.svg',
            'image/tiff': '.tif',
            'image/x-icon': '.ico',

            // Audio
            'audio/mpeg': '.mp3',
            'audio/wav': '.wav',
            'audio/ogg': '.ogg',
            'audio/mp4': '.m4a',
            'audio/flac': '.flac',

            // Video
            'video/mp4': '.mp4',
            'video/x-msvideo': '.avi',
            'video/quicktime': '.mov',
            'video/x-ms-wmv': '.wmv',
            'video/webm': '.webm',
            'video/x-matroska': '.mkv',

            // Archives
            'application/zip': '.zip',
            'application/x-zip-compressed': '.zip',
            'application/x-rar-compressed': '.rar',
            'application/x-7z-compressed': '.7z',
            'application/x-tar': '.tar',
            'application/gzip': '.gz',

            // Code / Markup / Config
            'text/html': '.html',
            'application/javascript': '.js',
            'application/json': '.json',
            'text/css': '.css',
            'application/xml': '.xml',
            'application/x-yaml': '.yaml',
            'text/markdown': '.md',
            'application/typescript': '.ts',

            // Fonts
            'font/woff': '.woff',
            'font/woff2': '.woff2',
            'application/x-font-ttf': '.ttf',
            'application/vnd.ms-fontobject': '.eot',

            // Fallback / binary
            'application/octet-stream': '.bin'
        };

        const extInName = filename.includes('.') ? filename.slice(filename.lastIndexOf('.')).toLowerCase() : '';
        const expectedExt = mimeToExtension[mimeType];

        if (!expectedExt) return filename; // Unknown MIME type, do nothing

        if (extInName === expectedExt) return filename; // Already has correct extension

        return filename + expectedExt; // Append extension
    }

}